/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useParams } from 'react-router-dom';

import { Form } from '@organisms';

import ArticleSelect from '../ArticleSelect';

const ArticleField = ({ onChange, isTypeFilter = false, ...props }) => {
  const { locale } = useParams();
  return (
    <Form.Item {...props}>
      <ArticleSelect onChange={onChange} queryVariables={{ language: locale }} isTypeFilter={isTypeFilter} />
    </Form.Item>
  );
};

export default ArticleField;
